import AxiosConfig from '../../../config/AxiosConfig';

const useEndDeploy = () => {
  const setEndDeploy = async (update) => {
    try {
      const res = AxiosConfig.create('put', `/system/end/`)
        .call(update)
        .getResponseData();
      return res;
    } catch (err) {
      console.error('Failed to end deploy:', err);
      throw new Error(`System deployment failed to end: ${err.message}`);
    }
  };
  return { setEndDeploy };
};

export default useEndDeploy;
